<template>
  <div id='app'>
    <nav class='navbar navbar-expand-md sticky-top navbar-dark bg-dark'>
      <router-link to="/">
        <a class="navbar-brand">Andrew's Key Pool</a>
      </router-link>
      <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#collapsibleNavbar" aria-controls="collapsibleNavbar" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="collapse navbar-collapse" id="collapsibleNavbar">
        <ul class="navbar-nav mr-auto mt-2 mt-lg-0">
          <li class="nav-item">
            <router-link to="/">
              <a class="nav-link">Home</a>
            </router-link>
          </li>
          <li class="nav-item" v-if="userIsInGroup('redeemers')">
            <router-link to="/submit">
              <a class="nav-link">Submit Key</a>
            </router-link>
          </li>
          <li class="nav-item" v-if="!signedIn">
            <router-link to="/auth">
              <a class="nav-link">Sign Up/Sign In</a>
            </router-link>
          </li>
          <li class="nav-item" v-if="userIsInGroup('admins')">
            <router-link to="/admin">
              <a class="nav-link">Admin Panel</a>
            </router-link>
          </li>
        </ul>
        <form class="form-inline my-2 my-lg-0" v-if="signedIn">
          <span class="navbar-text">
            Hello, {{ this.user.username }} ({{ getUserType() }})
          </span>
          <div style="width:15px;height:auto;display:inline-block;" />
          <button v-on:click='amplifySignOut' class="btn btn-outline-secondary btn-sm">Sign Out</button>
        </form>
      </div>
    </nav>
    <div style="padding-top: 30px;">
      <router-view :user="user"/>
    </div>
  </div>
</template>

<script>
import { Auth, Hub } from 'aws-amplify'

export default {
  name: 'app',
  data() {
    return {
      signedIn: false,
      user: {}
    }
  },
  beforeCreate() {
    // Listen for changes in auth state to update the header
    Hub.listen('auth', data => {
      const { payload } = data
      if (payload.event === 'signIn') {
        this.signedIn = true
        this.user = payload.data
        this.$router.push('/')
      }
      if (payload.event === 'signOut') {
        this.signedIn = false
        this.user = {}
        this.$router.push('/auth')
      }
    })

    // Load any existing state (non-expired tokens/page was refreshed)
    Auth.currentAuthenticatedUser()
      .then((user) => {
        this.user = user
        this.signedIn = true
      })
      .catch(() => this.signedIn = false)
  },
  methods: {
    userIsInGroup(group) {
      // The token payload holds an array of groups the user is in and indexOf will return the
      // index of the group name if it is found but -1 if it is not
      try {
        return this.user.signInUserSession.accessToken.payload['cognito:groups'].indexOf(group) > -1
      } catch {
        // User wasn't logged in so token didn't exist
        return false
      }
    },
    getUserType() {
      if (this.userIsInGroup('admins')) {
        return 'Admin'
      } else if (this.userIsInGroup('redeemers')) {
        return 'Active user'
      } else {
        return 'Awaiting approval'
      }
    },
    async amplifySignOut() {
      await Auth.signOut()
      .then(() => {
        Hub.dispatch(
          'auth', 
          { 
            event: 'signOut', 
            data: {}, 
            message:'' 
        })
      })
    }
  }
}
</script>